import { useTranslations } from '@vocab/react';
import { Box, OverflowMenu, MenuItem } from 'braid-design-system';
import React, { useCallback, type Dispatch, type SetStateAction } from 'react';

import { events, link } from 'src/modules/analyticsTracker';
import { getBrandReportUrl } from 'src/utils/urls';

import translations from './.vocab';
import BrandSearchInput from './Controls/BrandSearchInput';
import CreateBrandButton from './Controls/CreateBrandButton';

interface Props {
  onSearchBrands: Dispatch<SetStateAction<string>>;
  brandCount: number;
}

const BrandListControls = ({ onSearchBrands, brandCount }: Props) => {
  const openBrandList = useCallback(() => {
    link(events.VIEW_ALL_BRANDS_CLICKED);
    window.open(getBrandReportUrl());
  }, []);

  const { t } = useTranslations(translations);

  return (
    <Box
      display={['block', 'flex']}
      justifyContent="spaceBetween"
      alignItems="center"
    >
      <CreateBrandButton tone="brandAccent" />

      <Box marginBottom={['small', 'none']} />
      <Box display="flex" justifyContent="flexEnd" alignItems="center">
        {/* Only search when there are more than one brand */}
        {brandCount > 1 && <BrandSearchInput onChange={onSearchBrands} />}
        <Box marginX="gutter">
          <OverflowMenu label="Brand">
            <MenuItem onClick={openBrandList}>{t('View all brands')}</MenuItem>
          </OverflowMenu>
        </Box>
      </Box>
    </Box>
  );
};

export default BrandListControls;
